/**
 * @licence
 * Copyright 2021 ModBros OG
 * Licenced under apache Licence, Version 2.0
 */

/**
 * Do not edit directly!
 * Generated on Wed Oct 13 2021 19:02:58 GMT+0200 (Central European Summer Time)
 */

export const None = 'var(--modbros-none, 0)';
export const Size0 = 'var(--modbros-size-0, 0)';
export const Size2 = 'var(--modbros-size-2, 2px)';
export const Size4 = 'var(--modbros-size-4, 4px)';
export const Size6 = 'var(--modbros-size-6, 6px)';
export const Size8 = 'var(--modbros-size-8, 8px)';
export const Size12 = 'var(--modbros-size-12, 12px)';
export const Size16 = 'var(--modbros-size-16, 16px)';
export const Size20 = 'var(--modbros-size-20, 20px)';
export const Size24 = 'var(--modbros-size-24, 24px)';
export const Size32 = 'var(--modbros-size-32, 32px)';
export const Size38 = 'var(--modbros-size-38, 38px)';
export const Size42 = 'var(--modbros-size-42, 42px)';
export const Size48 = 'var(--modbros-size-48, 48px)';
export const Size56 = 'var(--modbros-size-56, 56px)';
export const Size64 = 'var(--modbros-size-64, 64px)';
export default {
  None,
  Size0,
  Size2,
  Size4,
  Size6,
  Size8,
  Size12,
  Size16,
  Size20,
  Size24,
  Size32,
  Size38,
  Size42,
  Size48,
  Size56,
  Size64,
}